import { render, staticRenderFns } from "./AppProductTilePricePlp.vue?vue&type=template&id=6d23750c&"
import script from "./AppProductTilePricePlp.vue?vue&type=script&lang=js&"
export * from "./AppProductTilePricePlp.vue?vue&type=script&lang=js&"
import style0 from "./AppProductTilePricePlp.vue?vue&type=style&index=0&id=6d23750c&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports